import * as yup from 'yup'

export const roomSchema = yup.object({
  price: yup.string(),
  room_number: yup.string().required('room number is required'),
  room_type: yup.string().required('room type is required')
})

export const departmentSchema = yup.object({
  location: yup.string(),
  name: yup.string().required('department name is required'),
  staff: yup.string()
})
